import React from 'react'
import '../styles/style.css'
import back from '../images/back.svg'
import add from '../images/add.svg'
import reduce from '../images/reduce.svg'
import time from '../images/time.svg'
import Loader from '../common/loader'
import { FRONT_END_NAME } from '../common/constants'
import { getContentHeaders, getPostApi,registerPlayerCount } from '../common/axiosConfig'
import apiUrls from '../common/apiUrls'
import Empty from './empty'
import Popup from '../common/addRemove'

class List extends React.Component {

    constructor(props){
        super(props);
        //debugger;
        var categoryDetails = props.location.state;
        if(!categoryDetails){
            categoryDetails = {
                categoryName : ""
            }
        }
        this.state = {
            categoryList : JSON.parse(localStorage[categoryDetails.title] || []),
            categoryName : categoryDetails.title,
            showLoader : false
        }

        console.log("categoryList",(localStorage[categoryDetails.title] || []));
        
    }

    playVideo = (item) =>{
        registerPlayerCount(item.itemId);
        this.props.history.push({pathname:FRONT_END_NAME+"/videoplay",state:{video:item}})
    }
    showLoader = () =>{
        this.setState({showLoader:true});
    }
    hideLoader = () =>{
        this.setState({showLoader:false});
    }

    goBack = () =>{
        debugger;
        if((sessionStorage["toSub"] == "true")){
            this.props.history.goBack()
        }
        else{
            this.props.history.push(FRONT_END_NAME+"/home");
        }
    }

    addToMyPlayList = (e,video,index) =>{
        console.log("event",e);
        e.stopPropagation();
        this.showLoader();
        var requestBody = {
            "contentId": video.itemId, //required
            "contentType": "video", //required
            "contentTitle": video.title,
            "description": sessionStorage["currentCategory"],
            "categoryImageURL":sessionStorage["previewImageUrl3"],
            "previewImageURL": video.smallPreviewImage,
            "content_url": video.video.feed,
            "duration": video.videoLength,
            "likes": video.likesCount,
            "views": video.viewCount,
            "hearts": video.heartCount,
            "encoding": video.video.encoding,
            "resolution": video.video.resolution,
            "contentDate": video.creationDate
        }
        getPostApi(apiUrls.addUserPlayList, getContentHeaders(), requestBody).then((response) => {
            if (response.data.code == 2000) {
               console.log("personalisedlist",response.data.data);
                this.hideLoader();
                var category = this.state.categoryList[index];
                var categoryList = this.state.categoryList;
                category.isItemSaved = true;
                categoryList[index] = category;
                this.setState({categoryList});
                this.showPopup("",video.title+" video added to My list",false);
            }

        })
    }

    removeFromPlayList = (e,video,index) => {
        console.log("event",e);
        e.stopPropagation();
        this.showLoader();
        var requestBody = {
            "contentId": video.itemId, //required
            
        }
        getPostApi(apiUrls.deleteUserPlaylist, getContentHeaders(), requestBody).then((response) => {
            if (response.data.code == 2000) {
                console.log("personalisedlist",response.data.data);
                this.hideLoader();
                var category = this.state.categoryList[index];
                var categoryList = this.state.categoryList;
                category.isItemSaved = false;
                categoryList[index] = category;
                this.setState({categoryList});
                this.showPopup("",video.title+" video removed from My list",true);
            }

        })
    }

    showPopup = (popupHeading,popupMsg,popupError) =>{
        this.setState({popupHeading,popupMsg,popupError,showPopup:true})
    }

    render() {
        console.log("category list",this.state.categoryList);
        return (
            <div className="container-list">
                {this.state.showPopup && <Popup
                error={this.state.popupError}
                heading={this.state.popupHeading}
                msg = {this.state.popupMsg}
                onClick = {()=>{this.setState({showPopup:false})}}
                ></Popup>}
                {this.state.showLoader && <Loader></Loader>}
                <div className="header-list">
                    <img onClick={this.goBack} src={back}></img>
                    <p>{this.state.categoryName}</p>
                </div>
                <div className="content-list">
                {this.state.categoryList == 0 && <Empty categoryName={this.state.categoryName}></Empty>}
                    {this.state.categoryList.map((item,index)=>
                    <div key={index} className="video-div-outer">
                    {console.log("item",item)}
                        <div className="video-div" style={{backgroundImage:`url(${item.videoPreviewImage})`}} onClick={()=>{this.playVideo(item)}}>
                            <img src={item.isItemSaved?reduce:add} className="video-div-img" onClick={item.isItemSaved?(e)=>this.removeFromPlayList(e,item,index):(e)=>this.addToMyPlayList(e,item,index)}></img>
                            <div className="time-divv">
                                {/* <img src={item.previewImage}></img> */}
                                <img src={time}></img>
                                <span className="time-clr">{item.video.duration}</span>
                            </div>
                        </div>
                        <p className="video-div-p">{item.title}</p>
                    </div>)}
                    
                    
                    
                </div>
            </div>
        );
    }
}

export default List;